import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'Guía Paso a Paso',
    desc: 'El cronómetro exacto para cocinar 10 platos en 120 minutos reales.'
  }, {
    title: 'Mapa de Compras',
    desc: 'Lista de lo que tenés que comprar en la verdulería y la carnicería para no desperdiciar ni un peso.'
  }, {
    title: 'La Ciencia del Congelado',
    desc: 'Qué sí y qué NO podés meter al freezer (y cómo recalentar para que no parezca una suela).'
  }, {
    title: "Menú 'Proteico' y 'Vegetales Ocultos'",
    desc: 'Ideal para que los chicos coman sano sin darse cuenta.'
  }, {
    title: 'Material Imprimible',
    desc: 'Listas de compras y etiquetas para que tu freezer parezca de revista.'
  }];
  return <section className="py-20 px-6 bg-cream" data-id="element-142">
      <div className="max-w-6xl mx-auto" data-id="element-143">
        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-144">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:w-1/2" data-id="element-145">
            <h2 className="text-3xl md:text-4xl font-serif text-forest font-bold mb-8" data-id="element-146">
              Lo que vas a recibir hoy:
            </h2>

            <div className="space-y-6" data-id="element-147">
              {items.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex gap-4 items-start" data-id="element-148">
                  <CheckCircle2 className="w-6 h-6 text-terracotta flex-shrink-0 mt-1" data-id="element-149" />
                  <div data-id="element-150">
                    <h4 className="font-bold text-forest text-lg" data-id="element-151">
                      {item.title}
                    </h4>
                    <p className="text-brown" data-id="element-152">{item.desc}</p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:w-1/2 relative" data-id="element-153">
            <div className="rounded-2xl overflow-hidden shadow-xl border-8 border-white" data-id="element-154">
              <img src="https://cdn.magicpatterns.com/uploads/b7KR4piYTGEUTNmwmffHBy/concepto_3.png" alt="Madre e hijo comiendo saludable" className="w-full h-auto object-cover" data-id="element-155" />
            </div>
            {/* Decorative badge */}
            <div className="absolute -bottom-6 -left-6 bg-terracotta text-white p-4 rounded-full shadow-lg w-32 h-32 flex items-center justify-center text-center font-bold transform -rotate-12 border-4 border-white" data-id="element-156">
              ¡Apto para
              <br data-id="element-157" />
              toda la
              <br data-id="element-158" />
              familia!
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}